import { render, staticRenderFns } from "./CameraPageShootMessageGeneralBook.vue?vue&type=template&id=34dd3db5&scoped=true&"
import script from "./CameraPageShootMessageGeneralBook.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootMessageGeneralBook.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootMessageGeneralBook.vue?vue&type=style&index=0&id=34dd3db5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dd3db5",
  null
  
)

export default component.exports